interface Props {
  children?: React.ReactNode;
}

export const FormButtonsContainer: React.FC<Props> = ({ children }) => {
  return <div className="flex justify-end">{children}</div>;
};
